import React from 'react';
import {useWatch} from 'react-hook-form';
import {FormViewComponentV2} from 'src/app/forms/FormViewComponent/FormViewComponentV2';
import type {IFormDataV2, IFormFieldV2} from 'src/types/FormV2';
import {useProactFormContext} from './ProactFormContext';

export interface ProactFormViewProps {
  /**
   * Restricts rendering to a subset of the form's metadata (e.g. one section
   * of a form whose other sections stay editable). Defaults to all fields.
   */
  formMeta?: IFormFieldV2[];
  formHeader?: React.ReactNode;
  limitItemsCount?: number;
  spacing?: 'compact' | 'normal';
}

/**
 * Read-only rendering of the current form values — the engine-native
 * counterpart to FormViewComponentV2. Must be rendered inside <ProactForm>;
 * it subscribes to the form's values so it stays in sync when other parts of
 * the form remain editable.
 */
export const ProactFormView: React.FC<ProactFormViewProps> = ({
  formMeta,
  formHeader,
  limitItemsCount,
  spacing,
}) => {
  const form = useProactFormContext();
  const values = useWatch({control: form.methods.control}) as IFormDataV2;

  return (
    <FormViewComponentV2
      formData={values}
      formMeta={formMeta ?? form.formMeta}
      formHeader={formHeader}
      limitItemsCount={limitItemsCount}
      spacing={spacing}
    />
  );
};
